module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-8"
  }, [(_vm.loading) ? _c('heading-loading') : _c('h1', [_c('i', {
    staticClass: "far fa-clipboard-list m-r-sm"
  }), _vm._v(" " + _vm._s(_vm.load.reference_number))])], 1), _vm._v(" "), (_vm.notLoading) ? _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('p', {
    staticClass: "job-status-header",
    class: _vm.load.status_class
  }, [_vm._v(_vm._s(_vm.load.status_text))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-15e4479e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/ShowHeading.vue
// module id = 936
// module chunks = 0